import { useMemo, useState } from 'react'
import { NavBar } from 'components/NavBar/NavBar'
import { Flex, PageWrapper, Tabs, TabsContainer } from 'styling/GlobalStyles'
import { Head1 } from 'styling/Typography'
import { tokens } from 'styling/tokens'
import useQueryPagination from 'hooks/useQueryPagination'
import { useHasPermission } from 'hooks/useHasPermission'
import { getFoodKitchens, getFoodMealWindows } from 'features/food/foodSlice'
import { DashboardTab } from './tabs/DashboardTab'
import { ExceptionsTab } from './tabs/ExceptionsTab'
import { MealRequestsTab } from './tabs/MealRequestsTab'
import { ProfilesTab } from './tabs/ProfilesTab'
import { ConfigurationTab } from './tabs/ConfigurationTab'
import { HistoryTab } from './tabs/HistoryTab'

const FOOD_TABS = ['Dashboard', 'Exceptions', 'Meal Requests', 'Profiles', 'Configuration', 'History']

export const Food = () => {
  const canKitchen = useHasPermission('kitchen')
  const [activeTab, setActiveTab] = useState('Dashboard')
  const [configurationToolbar, setConfigurationToolbar] = useState<React.ReactNode>(null)

  const params = useMemo(() => ({ page: 1, limit: 200 }), [])
  const fetchFunctions = useMemo(
    () => (canKitchen ? [getFoodMealWindows, getFoodKitchens] : [getFoodMealWindows]),
    [canKitchen],
  )

  useQueryPagination({
    fetchFunctions,
    cleanUpFunctions: [],
    params,
  })

  const handleTabChange = (tab: string) => {
    setActiveTab(tab)
    if (tab !== 'Configuration') setConfigurationToolbar(null)
  }

  return (
    <>
      <NavBar />
      <PageWrapper noFooter>
        <Flex between center mb='16'>
          <Head1 style={{ fontSize: '1.5rem', lineHeight: 1.3 }} color={tokens.text.primary}>
            Food
          </Head1>
        </Flex>
        <Flex between alignEnd mb='16' width='100%' wrap gap='1rem'>
          <TabsContainer>
            {FOOD_TABS.map((tab) => (
              <Tabs key={tab} active={activeTab === tab} onClick={() => handleTabChange(tab)}>
                {tab}
              </Tabs>
            ))}
          </TabsContainer>
          {activeTab === 'Configuration' && configurationToolbar}
        </Flex>
        {activeTab === 'Dashboard' && <DashboardTab />}
        {activeTab === 'Exceptions' && <ExceptionsTab />}
        {activeTab === 'Meal Requests' && <MealRequestsTab />}
        {activeTab === 'Profiles' && <ProfilesTab />}
        {activeTab === 'Configuration' && (
          <ConfigurationTab onToolbarChange={setConfigurationToolbar} />
        )}
        {activeTab === 'History' && <HistoryTab />}
      </PageWrapper>
    </>
  )
}
